// Stub for @okta/ui-libraries-monolith (not used by the sign-in widget)
export class OktaPageData {
  constructor() {}
  get() { return undefined; }
  getAll() { return undefined; }
}
